import { render } from "./NestedDraggable.vue?vue&type=template&id=00b142ff"
import script from "./NestedDraggable.vue?vue&type=script&lang=js"
export * from "./NestedDraggable.vue?vue&type=script&lang=js"

import "./NestedDraggable.vue?vue&type=style&index=0&id=00b142ff&lang=css"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__